// extracted by mini-css-extract-plugin
module.exports = {"outer-container":"special-states__outer-container___239_I","inner-container":"special-states__inner-container___1UUT7"};